module.exports = __webpack_public_path__ + "img/haze.2f33504d.svg";